import React from 'react'
import AboutEvent from '../../molecules/about-event/aboutEvent'
import GuideTo from '../../molecules/guided-to/guideTo'
import DictatedBy from '../../molecules/dictated-by/dictatedBy'
import './about-content.scss'

const aboutContent = props => {
  const { data } = props

  return (
    <div className='m-about-content' id='evento'>
      {data.dictadoPor ? (
        <>
          <AboutEvent aboutInfo={data.sobreElEvento} />
          <DictatedBy
            dictatedByInfo={data.dictadoPor}
            colorPrincipal={data.colorPrincipal}
            tituloDictadoPor={data.tituloDictadoPor}
          />
        </>
      ) : (
        <>
          <AboutEvent
            aboutInfo={data.sobreElEvento}
            subtitle={data.subtitle ? data.subtitle : false}
          />
          {data.dirigidoA && (
            <GuideTo
              guideInfo={data.dirigidoA}
              colorPrincipal={data.colorPrincipal}
            />
          )}
        </>
      )}
    </div>
  )
}

export default aboutContent
